module.exports = __webpack_public_path__ + "img/ps.ed5a603b.jpg";